import { createStore } from 'stimulus-store';

/**
 * Store to mark that the CURRENT device load is a silent, greedy background
 * prefetch (the initial autoLoad on Manage Devices / Manage Bundles) rather
 * than a user-initiated load the user is actively waiting on.
 *
 * States:
 * - true:  A background prefetch is in flight. Consumers that show the shared
 *          loading overlay should stay silent — the user did not ask for data
 *          yet, so flashing a spinner on page load is confusing.
 * - false: No background prefetch is in flight. Loads happening now are
 *          user-initiated (e.g. clicking Apply, selecting an area) and SHOULD
 *          surface the overlay.
 *
 * This is separate from `devicesLoadingStore`, which must remain accurate for
 * ALL loads (the Apply path relies on it via waitForDevices()). This flag only
 * governs whether the store-driven overlay is shown, not whether a load is
 * happening.
 */
export const devicesBackgroundLoadStore = createStore({
    name: 'devicesBackgroundLoadStore',
    type: Boolean,
    initialValue: false
});
